import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "rel"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    href: $props.href,
    target: $options.urlTarget,
    rel: $options.urlRel,
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8 /* PROPS */, _hoisted_1))
}